import moment from 'moment';

class CreateLaborCategoryModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";

    this.name = 'CreateLaborCategoryModal';

    $http.get($rootScope.apiHost+"/api/admin/companies/1/degrees", {withCredentials: true}).then(function (success) {
      $scope.companyDegrees = success.data;
    });

    $scope.laborCategory = $uibModalInstance.laborCategory

    $scope.cancel = function () {
      $scope.laborCategory = {};
      $uibModalInstance.cancel();
    };

    $scope.saveLaborCategory = function() {
      $uibModalInstance.success($scope.laborCategory);
    }

    $scope.cancel = function() {
      $uibModalInstance.cancel();
    }

    $scope.missingRequiredValues = function() {

      let allBasicInformationComplete = $scope.laborCategory.shortName && $scope.laborCategory.name && $scope.laborCategory.name;
      let allQualificationInformationComplete = $scope.laborCategory.minimumYearsOfExperienceWithDegree && $scope.laborCategory.minimumYearsOfExperienceWithoutDegree && $scope.laborCategory.maximumYearsOfExperienceWithDegree && $scope.laborCategory.maximumYearsOfExperienceWithoutDegree;

      return !allBasicInformationComplete && !allQualificationInformationComplete;
    }

    $scope.addAcceptableDegreeToLcat = function() {
      if(!$scope.laborCategory) {
        $scope.laborCategory = {}
      }

      if(!$scope.laborCategory.applicableDegrees) {
        $scope.laborCategory.applicableDegrees = [];
      }

      $scope.laborCategory.applicableDegrees.push($scope.degreeToAdd);
      $scope.degreeToAdd = undefined;
      console.log($scope.laborCategory);
    }

    $scope.selectDegree = function($item, $model, $label) {
      $scope.degreeToAdd = $item;
    }

  }
}

export default CreateLaborCategoryModalController;



// WEBPACK FOOTER //
// ./client/common/modals/createLaborCategoryModal/createLaborCategoryModal.controller.js